<template>
  <base-wrapper>
    <datatable
      :total="notifications.meta.page.total"
      :perPage="notifications.meta.page.perPage"
      :currentPage="notifications.meta.page.currentPage"
      :columns="[
        { id: 'date', name: 'Tanggal' },
        { id: 'name', name: 'Nama' },
        { id: 'content', name: 'Isi' },
        { id: 'action', name: 'Aksi' },
      ]"
      @pagechanged="onChangePage"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="notification in notifications.data"
          :key="notification.id"
          :class="[classes.tr, 'bg-white']"
        >
          <td :class="classes.td">
            {{ notification.attributes.createdAt | formatDate }}
          </td>
          <td :class="classes.td">
            <p class="flex items-center gap-2">
              <Icon
                v-if="!notification.attributes.readAt"
                icon="mdi:circle"
                class="h-3 w-3 text-green-600"
              />
              <span>{{ notification.attributes.name }}</span>
            </p>
          </td>
          <td :class="classes.td">{{ notification.attributes.message }}</td>
          <td :class="classes.td">
            <button
              v-if="!notification.attributes.readAt"
              @click="onRead(notification)"
            >
              <Icon
                icon="heroicons:check-circle"
                class="h-5 w-5 text-green-600"
              />
            </button>
          </td>
        </tr>
      </template>
    </datatable>

    <loading v-if="loading || loadingRead" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '../mixins/request/request';

export default {
  mixins: [requestMixin],
  data() {
    return {
      loading: false,
      loadingRead: false,
      notifications: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  methods: {
    async loadNotifications(params) {
      this.loading = true;

      const [res, err] = await this.request(`/api/v1/notifications`, {
        params: {
          'page[size]': 5,
          sort: 'null_read_at,-createdAt',
          ...params,
        },
      });

      if (!err) {
        this.notifications = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadNotifications({ 'page[number]': page });
    },
    async onRead(notification) {
      this.loadingRead = true;

      const [, err] = await this.request(
        `/api/v1/notifications/${notification.id}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'notifications',
              id: notification.id,
              attributes: {
                readAt: new Date(),
              },
            },
          },
        }
      );

      if (!err) {
        this.loadNotifications();
      }

      this.loadingRead = false;
    },
  },
  created() {
    this.loadNotifications();
  },
};
</script>
